import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMedicalExamNo = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "medicalExam-no",
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", {
			id: "Group_17534",
			"data-name": "Group 17534",
			transform: "translate(2 2.027)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					id: "Path_12986",
					"data-name": "Path 12986",
					d: "M16.1,6.853,13.33,4.08",
					transform: "translate(-10.99 -3.387)",
					fill: "none",
					stroke: "currentColor",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					strokeWidth: 1
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_12987",
					"data-name": "Path 12987",
					d: "M15.86,6.6l2.767,2.773",
					transform: "translate(-15.2 -4.227)",
					fill: "none",
					stroke: "currentColor",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					strokeWidth: 1
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_12988",
					"data-name": "Path 12988",
					d: "M15.817,5.86,10.95,10.72",
					transform: "translate(-9.117 -3.98)",
					fill: "none",
					stroke: "currentColor",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					strokeWidth: 1
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_12989",
					"data-name": "Path 12989",
					d: "M3,17.45l2.433,2.433",
					transform: "translate(6.567 -7.843)",
					fill: "none",
					stroke: "currentColor",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					strokeWidth: 1
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_12990",
					"data-name": "Path 12990",
					d: "M8.353,12.35l-.973.973",
					transform: "translate(0.727 -6.143)",
					fill: "none",
					stroke: "currentColor",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					strokeWidth: 1
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_12992",
					"data-name": "Path 12992",
					d: "M19.483,3.04,16.45,6.073",
					transform: "translate(-16.45 -3.04)",
					fill: "none",
					stroke: "currentColor",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					strokeWidth: 1
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_12993",
					"data-name": "Path 12993",
					d: "M8.439,13.4l1.206,1.229a1.333,1.333,0,0,0,1.885,0l1.071-1.07a1.333,1.333,0,0,0,0-1.885c-.521-.521-1.32-1.338-1.32-1.338",
					transform: "translate(-2.517 -4.465)",
					fill: "none",
					stroke: "currentColor",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					strokeWidth: 1
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_12996",
					"data-name": "Path 12996",
					d: "M5.113,8.052,2.559,5.518",
					fill: "none",
					stroke: "currentColor",
					strokeWidth: 1
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_12997",
					"data-name": "Path 12997",
					d: "M4.858,7.773l-2.3-2.255",
					transform: "translate(3 -2.821)",
					fill: "none",
					stroke: "currentColor",
					strokeWidth: 1
				})
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12994",
			"data-name": "Path 12994",
			d: "M16,0H0V16H16Z",
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12995",
			"data-name": "Path 12995",
			d: "M13.748,10,9,20.888",
			transform: "translate(3.55 -10.302) rotate(22)",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1
		})
	]
});
export default SvgMedicalExamNo;
